import { Alert, Dialog, DialogTitle } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import Segment from '../../interfaces/Segment';
import RMFConfigForm from '../RFMConfigForm/RFMConfigForm';
import { hasOverlapping } from '../../services';
import getRandomId from '../../../../utils/getRandomId';

interface RMFConfigDialogProps {
  segments: Segment[];
  config?: Segment;
  open: boolean;
  onClose: () => void;
  onUpdate: (config: Segment) => Promise<void>;
}

const RMFConfigDialog: FC<RMFConfigDialogProps> = ({
  config,
  open,
  segments,
  onClose,
  onUpdate,
}) => {
  const [error, setError] = useState<string | null>(null);

  const handleOnUpdateAndClose = async (newSegment: Segment) => {
    setError(null);
    const overlapping = hasOverlapping(segments, newSegment);
    if (overlapping) {
      setError(
        `'${newSegment.name}' is overlapping with '${overlapping.name}'.`
      );
      return Promise.reject();
    }

    newSegment.id = getRandomId();

    return onUpdate(newSegment)
      .then(() => onClose())
      .catch((error: Error) => setError(error.message));
  };

  useEffect(() => {
    return () => setError(null);
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>RFM Config</DialogTitle>
      <RMFConfigForm
        errorElement={
          error ? (
            <Alert sx={{ mb: 3 }} severity='error'>
              {error}
            </Alert>
          ) : null
        }
        segments={segments}
        config={config}
        onUpdate={handleOnUpdateAndClose}
        onClose={onClose}
      />
    </Dialog>
  );
};
export default RMFConfigDialog;
